<template>
  <div class="order-center">
    <div class="container">
      <div class="status-list">
        <div
          class="status-item"
          v-for="(v, k) in status_list"
          :key="`s` + k"
          :class="{ active: form_data.status === k }"
          @click="change_status(k)"
        >
          {{ v.name }}
          <template v-if="v.count > 0 || true">({{ v.count }})</template>
        </div>
        <div class="search">
          <img
            src="../../assets/images/icon-search.png"
            alt=""
            class="icon-search"
          />
          <input
            type="text"
            placeholder="搜索订单号"
            v-model="form_data.keyword"
            class="input"
            @keyup.enter="search"
          />
        </div>
      </div>

      <template v-if="order_list.length > 0">
        <div class="list">
          <div class="item">
            <div class="th">
              <div class="info">订单信息</div>
              <div class="category">订单类型</div>
              <div class="price">需求数量</div>
              <div class="period">交付时间</div>
              <div class="status">状态</div>
              <div class="action">操作</div>
            </div>
          </div>
          <div
            class="item td"
            v-for="(v, k) in order_list"
            :key="`or` + k"
            @click="go2detail(v.uuid)"
          >
            <div class="title flex align-center">
              <span @click.stop="copyOrderNo(v.order_no)"
                >订单号：{{ v.order_no }}</span
              >
              <img
                class="margin-left-10"
                @click.stop="copyOrderNo(v.order_no)"
                src="../../assets/images/patternMaker/ico_copy.png"
                style="width: 14px; height: 14px"
              />
              <div @click.stop="showChat(v)" class="flex align-center chat-entry">
                <img
                  class="margin-left-30"
                  src="../../assets/images/procurement/ico_chat.png"
                  style="width: 22px; height: 22px"
                />
                <span class="text-666 margin-left-10 text-13">联系客服</span>
                <span
                  class="unread-badge"
                  v-if="unreadMap[v.uuid] > 0"
                  >{{ unreadMap[v.uuid] > 99 ? '99+' : unreadMap[v.uuid] }}</span
                >
              </div>

              <!-- <template>
                <img class="margin-left-30" src="../../assets/images/patternMaker/ico_time.png" style="width:14px;height:14px;"  />
                <span class="text-red margin-left-10 text-13">派单剩余处理时间:2小时28分(超时自动拒绝)</span>
              </template> -->
            </div>
            <div class="content td">
              <div class="info">
                <div
                  class="sub-info"
                >
                  <div class="left">
                    <img
                      :src="getFirstImage(v) | default_img"
                      alt=""
                      class="image"
                    />
                  </div>
                  <div class="right">
                    <div class="sub-name">
                      {{ v.material_name }}
                    </div>
                    <div class="sub-create-time">
                      派单时间：{{ v.assign_time }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="category">
                <div
                  class="sub-info"
                >
                  {{
                    v.material_type == 1
                      ? "面料采购"
                      : v.material_type == 2
                      ? "打色采购"
                      : "辅料采购"
                  }}
                </div>
              </div>
              <div class="price">{{ v.required_quantity }}{{ v.material_unit }}</div>
              <div class="period">
                <!-- <div class="text-bold">1天内</div> -->
                <div class="text-999">{{ v.date_required }}之前</div>
              </div>
              <div class="status" :class="oc(v)">
                {{ v.status_name }}
              </div>
              <div class="action">
                <div
                  class="btn btn-pay"
                  @click.stop="acceptOrder(v)"
                  v-if="v.status == 0"
                >
                  我要接单
                </div>
                <div
                  class="btn btn-refuse"
                  @click.stop="refuseOrder(v)"
                  v-if="v.status == 0"
                >
                  拒绝接单
                </div>
                <div class="btn-customer" @click="go2detail(v.uuid)">
                  查看详情
                </div>
              </div>
            </div>
          </div>
        </div>
        <Page
          :current="page"
          :page-size="size"
          :total="total"
          @on-change="changePage"
          show-total
          style="margin-top: 20px"
          show-sizer
          @on-page-size-change="changeSize"
          :page-size-opts="[5, 10, 20]"
        ></Page>
      </template>
      <template v-else>
        <img
          src="../../assets/images/no-data.png"
          style="width: 300px; display: block; margin: 0 auto"
          alt=""
        />
      </template>

      <AcceptOrder ref="AcceptOrder" @confirm="getOrderList"></AcceptOrder>
      <RefuseOrder ref="RefuseOrder" @confirm="getOrderList"></RefuseOrder>
      <ProcurementChat ref="ProcurementChat"></ProcurementChat>
    </div>
  </div>
</template>

<script>
import {
  GetOrderList,
  GetOrderCount,
  GetProcurementChatUnread,
} from "@/api/procurement.js";
import axios from "axios";
import AcceptOrder from "./components/Accept";
import RefuseOrder from "./components/Refuse";
import ProcurementChat from "./components/ProcurementChat.vue";

export default {
  name: "OrderCenter",
  components: {
    AcceptOrder,
    RefuseOrder,
    ProcurementChat,
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: -1,
      unreadMap: {},
      form_data: {
        keyword: "",
        status: "all",
      },
      status_list: {
        all: { name: "全部订单", value: "all", count: 0 },
        wait_reply: { name: "待接单", value: "wait_reply", count: 0 },
        wait_delivery: { name: "待发货", value: "wait_delivery", count: 0 },
        wait_confirm: { name: "已发货", value: "wait_confirm", count: 0 },
        complete: { name: "待结算", value: "complete", count: 0 },
        settled: { name: "已结算", value: "settled", count: 0 },
        rejected: { name: "已拒绝", value: "rejected", count: 0 },
        invalid: { name: "已作废", value: "invalid", count: 0 },
      },
      order_list: [],
    };
  },
  watch: {
    "form_data.status": function (newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.getOrderList();
    },
  },
  computed: {},
  mounted() {
    this.change_status("all");
    axios.all([this.getOrderList()]).then(axios.spread(() => {}));
    this.getUnread();
    // 收到新采购消息或会话关闭后刷新未读角标
    this.$EventBus.$on("procurement-message", this.getUnread);
    this.$EventBus.$on("procurement-unread-refresh", this.getUnread);
  },
  beforeDestroy() {
    this.$EventBus.$off("procurement-message", this.getUnread);
    this.$EventBus.$off("procurement-unread-refresh", this.getUnread);
  },
  methods: {
    // 兼容多种图片字段：优先 material_images 数组，否则 material_image 字符串
    getFirstImage(v) {
      if (Array.isArray(v.material_images) && v.material_images.length > 0) {
        const first = v.material_images[0];
        if (typeof first === "string") return first;
        return first && first.url ? first.url : "";
      }
      return v.material_image || "";
    },
    acceptOrder(e) {
      this.$refs.AcceptOrder.showModal(e);
    },
    refuseOrder(e) {
      this.$refs.RefuseOrder.showModal(e);
    },
    showChat(v) {
      // 与订单对应采购人员沟通（独立沟通模块）
      const employee = v.employee || {};
      this.$refs.ProcurementChat.open(v.uuid, {
        true_name: employee.true_name,
        avatar: employee.avatar,
        order_no: v.order_no,
      });
    },
    // 拉取订单未读（红色角标）
    async getUnread() {
      try {
        const { data } = await GetProcurementChatUnread();
        this.unreadMap = data || {};
      } catch (e) {
        // ignore
      }
    },
    async copyOrderNo(order_no) {
      if (!order_no) return;
      await navigator.clipboard.writeText(order_no);
      this.$layer.msg("复制成功");
    },
    search() {
      this.getOrderList();
    },

    oc(v) {
      return [v.status_text];
    },
    go2detail(uuid) {
      this.$router.push({ name: "ProcurementOrderDetail", query: { uuid } });
    },
    changePage(page) {
      this.page = page;
      this.getOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },

    async getOrderList() {
      this.order_list = [];
      return GetOrderList({
        ...this.form_data,
        page: this.page,
        size: this.size,
      })
        .then((response) => {
          this.order_list = response.data.list;
          this.total = response.data.total;
          return GetOrderCount(this.form_data);
        })
        .then((response) => {
          for (let code in response.data) {
            this.status_list[code].count = response.data[code];
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      position: relative;
      padding: 30px 0;
      display: flex;
      align-content: center;
      .status-item {
        margin: 0 14px;
        width: 90px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .search {
        position: absolute;
        top: 23px;
        right: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 20px;
          width: 20px;
          height: 20px;
        }
        .input {
          width: 260px;
          height: 50px;
          line-height: 50px;
          border-radius: 25px;
          padding-left: 50px;
          background: #f3f4f6;
          font-size: 14px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        &:first-child {
          border: none;
        }
        cursor: pointer;
        color: #191a1c;
        overflow: hidden;
        .title {
          height: 52px;
          line-height: 52px;
          padding-left: 20px;
          color: #191a1c;
          background: #f6f7fa;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          .chat-entry {
            position: relative;
            .unread-badge {
              position: absolute;
              top: 8px;
              left: 52px;
              min-width: 16px;
              height: 16px;
              line-height: 16px;
              padding: 0 4px;
              background: #ff4d4f;
              color: #fff;
              font-size: 11px;
              border-radius: 8px;
              text-align: center;
            }
          }
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          &:first-child {
            border: none;
          }
          color: #575859;
          font-size: 14px;
          overflow: hidden;
          .info {
            width: 430px;
          }
          .category {
            width: 200px;
          }
          .price {
            width: 200px;
          }
          .period {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 300px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 430px;

            .sub-info {
              display: flex;
              padding: 10px;
              .left {
                .image {
                  width: 96px;
                  height: 96px;
                  border-radius: 8px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 96px;
                .sub-name {
                  width: 100%;
                  color: #333333;
                  font-size: 14px;
                  font-weight: bold;
                }
                .sub-create-time {
                  width: 100%;
                  font-weight: 400;
                  font-size: 13px;
                  color: #666666;
                  margin-top: 10px;
                }
              }
            }
          }
          .category {
            width: 200px;
          }
          .price {
            width: 200px;
            font-weight: 400;
            font-size: 14px;
            color: #ff5000;
          }
          .period {
            width: 200px;
            font-size: 14px;
          }
          .status {
            width: 200px;
            font-size: 14px;
            &.wait_reply {
              color: #FF5000;
            }
            &.wait_delivery {
              color: #0d99ff;
            }
            &.wait_confirm {
              color: #02c160;
            }
            &.complete {
              color: #ff5000;
            }

            &.settled {
              color: #666666;
            }
            &.rejected {
              color: #999999;
            }
            &.invalid {
              color: #999999;
            }
          }
          .action {
            width: 300px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 10px;
            .btn {
              width: 126px;
              height: 30px;
              line-height: 30px;
              background: #ff5967;
              border-radius: 4px;
              font-size: 14px;
              color: #333333;
              text-align: center;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
              &.btn-refuse {
                background: #ffffff;
                border: 1px solid #e3e3e3;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}
</style>
